(function () {
  var STORAGE_KEY = 'ragaviPaymentPreference';
  var ATTRIBUTE_NAME = 'Payment preference';
  var DEFAULT_VALUE = 'Pay online';
  var ALLOWED = { 'Pay online': true, 'Cash on delivery': true };

  function storedValue() {
    try {
      return sessionStorage.getItem(STORAGE_KEY);
    } catch (error) {
      return null;
    }
  }

  function remember(value) {
    try {
      sessionStorage.setItem(STORAGE_KEY, value);
    } catch (error) {
      /* Private mode can block sessionStorage. Cart attributes still save. */
    }
  }

  function getPreference() {
    var stored = storedValue();
    if (stored && ALLOWED[stored]) return stored;

    var selected = document.querySelector('[data-cart-payment-option][aria-checked="true"]');
    var fromDom = selected && selected.getAttribute('data-cart-payment-option');
    if (fromDom && ALLOWED[fromDom]) return fromDom;

    return DEFAULT_VALUE;
  }

  function applyPreference(value) {
    var next = ALLOWED[value] ? value : DEFAULT_VALUE;
    document.querySelectorAll('[data-cart-payment-option]').forEach(function (button) {
      var selected = button.getAttribute('data-cart-payment-option') === next;
      button.setAttribute('aria-checked', selected ? 'true' : 'false');
      button.classList.toggle('is-selected', selected);
    });
  }

  function savePreference(value, done) {
    var next = ALLOWED[value] ? value : DEFAULT_VALUE;
    remember(next);
    applyPreference(next);

    var url = (window.routes && window.routes.cart_update_url) || '/cart/update.js';
    var body = { attributes: {} };
    body.attributes[ATTRIBUTE_NAME] = next;

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function () {
        if (typeof done === 'function') done();
      })
      .catch(function () {
        if (typeof done === 'function') done();
      });
  }

  document.addEventListener('click', function (event) {
    var option = event.target.closest('[data-cart-payment-option]');
    if (!option) return;

    event.preventDefault();
    savePreference(option.getAttribute('data-cart-payment-option'));
  });

  document.addEventListener('keydown', function (event) {
    var option = event.target.closest('[data-cart-payment-option]');
    if (!option) return;
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft' && event.key !== 'ArrowUp' && event.key !== 'ArrowDown') {
      return;
    }

    var group = option.closest('[data-cart-payment-choice]');
    if (!group) return;
    var options = Array.from(group.querySelectorAll('[data-cart-payment-option]'));
    var index = options.indexOf(option);
    if (index < 0) return;

    event.preventDefault();
    var delta = event.key === 'ArrowLeft' || event.key === 'ArrowUp' ? -1 : 1;
    var next = options[(index + delta + options.length) % options.length];
    next.focus();
    savePreference(next.getAttribute('data-cart-payment-option'));
  });

  function syncFromStorage() {
    var stored = storedValue();
    if (stored && ALLOWED[stored]) applyPreference(stored);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncFromStorage);
  } else {
    syncFromStorage();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, syncFromStorage);
  }

  window.ragaviCartPayment = {
    get: getPreference,
    set: savePreference,
  };
})();
